import { render } from "./Loader.vue?vue&type=template&id=69ba571e&scoped=true"
const script = {}

import "./Loader.vue?vue&type=style&index=0&id=69ba571e&scoped=true&lang=css"

import exportComponent from "/builds/site-palette/palette.site-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69ba571e"]])

export default __exports__